import {
    CHANGE_PULS_CUSTOMER_REQUEST,
    CHANGE_PULS_CUSTOMER_RESULT,
    CHANGE_PULS_CUSTOMER_OPEN_MODAL,
    CHANGE_PULS_CUSTOMER_CLOSE_MODAL,
    CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST,
    CHANGE_PULS_CUSTOMER_GET_DEVICE_RESULT,
    CHANGE_PULS_CUSTOMER_SET_DEVICE,
    CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST,
    CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_RESULT,
    CHANGE_PULS_UPDATE_ACCOUNT_REQUEST,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    selectedDevices: [],
    calampApi: null,
    ctcAccounts: [],
    response: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CHANGE_PULS_CUSTOMER_REQUEST:
            return { ...state, loading: true }

        case CHANGE_PULS_CUSTOMER_RESULT:
            return { ...state, loading: false, result: action.payload.result, response: action.payload.response }

        case CHANGE_PULS_CUSTOMER_OPEN_MODAL:
            return { ...state, openModal: true, selectedDevices: action.payload.items, calampApi: action.payload.calampApi }

        case CHANGE_PULS_CUSTOMER_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case CHANGE_PULS_CUSTOMER_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case CHANGE_PULS_CUSTOMER_SET_DEVICE:
            return { ...state, devices: action.payload }

        case CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST:
            return { ...state, loading: true }

        case CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_RESULT:
            return { ...state, loading: false, ctcAccounts: action.payload }

        case CHANGE_PULS_UPDATE_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case CLEAR_REDUX:
            return ["", "CHANGE_PULS_CUSTOMER"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};